import { useCallback, useState } from 'react';
import AppConfig from '../AppConfig';
import { fetchDropboxSelectionAsFiles } from '../utils/dropboxChooser';
import { toaster } from '../utils/toast';
import useDropboxChooserButton from './useDropboxChooserButton';

// The native Chooser hands back links, not bytes, so a selection is only ready once the PFQ proxy
// has resolved every picked file and folder into real File objects.
const useEasyModeDropboxImport = ({ onFilesReady }) => {
  const [isImporting, setIsImporting] = useState(false);
  const isConfigured = Boolean(AppConfig.DropboxAppKey);

  const handleSelection = useCallback(
    async (selection) => {
      setIsImporting(true);

      try {
        const files = await fetchDropboxSelectionAsFiles(selection);

        if (files.length === 0) {
          toaster({ message: 'Nothing could be imported from that selection', success: false });
          return;
        }

        onFilesReady({ files });
      } catch (error) {
        toaster({ message: 'Could not import from Dropbox', success: false });
        console.error('Error importing Dropbox files:', error);
      } finally {
        setIsImporting(false);
      }
    },
    [onFilesReady]
  );

  const { openChooser, isReady, isSupported } = useDropboxChooserButton({
    appKey: AppConfig.DropboxAppKey,
    isEnabled: isConfigured,
    isFolderSelectEnabled: true,
    onSuccess: handleSelection
  });

  return {
    isEnabled: isConfigured && isSupported,
    isReady,
    isImporting,
    openPicker: openChooser
  };
};

export default useEasyModeDropboxImport;
